import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-hulk-config-input',
    templateUrl: './hulk-config-input.component.html',
    styleUrls: ['./hulk-config-input.component.scss']
})
export class HulkConfigInputComponent implements OnInit {

    @Input() oneColumn:any;
    @Input() attributes: any;
    @Input() label: any;
    @Input() nzSpanLable = 3;
    @Input() nzSpanInput = 21;

    constructor() {
    }

    ngOnInit() {
    }

    removeValue() {
        this.oneColumn[this.attributes] = null;
    }
}
